import { CellAction } from "./cell-action";

import { ComplaintsType } from "@/src/data/types";
import { showDate } from "../../../lib/dateFormater";
import { ColumnDef } from "@tanstack/react-table";

export const columns: ColumnDef<ComplaintsType>[] = [
  {
    accessorKey: "firstName",
    header: "NOM & PRENOM",
    cell: ({ row }) => {
      const { firstName, lastName } = row.original;
      return `${firstName} ${lastName}`;
    },
  },

  {
    accessorKey: "email",
    header: "EMAIL",
  },
  {
    accessorKey: "company",
    header: "SOCIETE",
  },
  {
    accessorKey: "message",
    header: "MESSAGE",
    cell: ({ row }) => {
      const message = row.original.message;
      return message.length > 10 ? `${message.slice(0, 10)}...` : message;
    },
  },
  {
    accessorKey: "createdAt",
    header: "DATE",
    cell: ({ row }) => {
      return showDate(row.original.createdAt);
    },
  },
  // {
  //   accessorKey: "status",
  //   header: "STATUS",

  //   cell: ({ row }) => {
  //     return (
  //       <Badge
  //         className={`${
  //           row.original.status === "Résolue"
  //             ? "bg-green-500"
  //             : row.original.status === "En attente"
  //             ? "bg-yellow-500"
  //             : row.original.status === "En cours"
  //             ? "bg-orange-500"
  //             : ""
  //         }  w-1/2 `}
  //       >
  //         {row.original.status}
  //       </Badge>
  //     );
  //   },
  // },

  {
    accessorKey: "actions",
    header: "ACTIONS",
    id: "actions",
    cell: ({ row }) => <CellAction data={row.original} />,
  },
];
